import { useCallback, useEffect, useRef, forwardRef } from 'react';
import { MTableHeader } from '@material-table/core';

const CustomHeader = forwardRef((props, ref) => {
  const { columns, orderByCollection, sorting, options } = props;

  const localRef = useRef(null);

  const setRefs = useCallback((node) => {
      localRef.current = node;
      if (!ref) return;
      if (typeof ref === 'function') {
        ref(node);
      } else {
        ref.current = node;
      }
  }, [ref]);

  useEffect(() => {
    const headerNode = localRef.current;
    if (!headerNode) return;

    const listeners = [];
    headerNode.querySelectorAll('th').forEach((th) => {
      const sortLabel = th.querySelector('.MuiTableSortLabel-root');
      if (!sortLabel) return;

      let scheduled = false;
      const scheduleSort = () => {
        if (scheduled) return; // Collapse duplicate pointer or clicks into one
        scheduled = true;
        setTimeout(() => {
          scheduled = false;
          sortLabel.click();
        }, 0);
      };

      const onPointerUp = (event) => {
        if (event.isTrusted) scheduleSort();
      };

      const onClickCapture = (event) => {
        if (event.isTrusted) event.stopPropagation();
      };

      th.addEventListener('pointerup', onPointerUp);
      th.addEventListener('click', onClickCapture, true);
      listeners.push({ th, onPointerUp, onClickCapture });
    });

    return () => {
      listeners.forEach(({ th, onPointerUp, onClickCapture }) => {
        th.removeEventListener('pointerup', onPointerUp);
        th.removeEventListener('click', onClickCapture, true);
      });
    };
  }, [columns, orderByCollection, sorting, options]);

  return <MTableHeader {...props} ref={setRefs} />;
});

export default CustomHeader;